<template><div></div></template>

<script>
import { ROUTES } from "../constants/routes";
import { launchToast } from "../utils/toast";

export default {
  name: "SessionExpired",
  created() {
    this.$store.dispatch("saveSessionId", "");
    this.$store.dispatch("saveWebId", "");
    localStorage.removeItem("webId");
    localStorage.removeItem("sessionId");
    this.$router.push(ROUTES.HOME.path).then(()=>launchToast("Your session has expired","is-info"));
  },
};
</script>

<style scoped></style>
